import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/components/Footer.css";

const Footer = () => (
  <footer className="footer">
    <Link to="/about">about</Link>
    <Link to="/">Terminos de uso</Link>
    <Link to="/">Declaración de privacidad</Link>
    <Link to="/">Centro de ayuda</Link>
  </footer>
);

export default Footer;
